import { render, staticRenderFns } from "./ListMarketPlace.vue?vue&type=template&id=40a97626"
import script from "./ListMarketPlace.vue?vue&type=script&lang=js"
export * from "./ListMarketPlace.vue?vue&type=script&lang=js"
import style0 from "./ListMarketPlace.vue?vue&type=style&index=0&id=40a97626&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports